module.exports = __webpack_public_path__ + "img/cuenta_verificada.70170df8.svg";